<template>
  <div>
  <div class="card-header d-flex justify-content-between">
  </div>
  <div class="card-body bg-info">
    <div class="card-text">
      <form @submit.prevent="saveVoucher" data-testid="visit-voucher-form">
        <div class="form-row align-items-end">
          <div class="col-sm-11 mb-2">
            <label for="searchMedicalDevice">Zdravotnický prostředek</label>
            <multiselect v-model="selected" id="searchMedicalDevice" label="label" track-by="code" open-direction="bottom" placeholder="vyhledat zdravotnický prostředek" data-testid="visit-voucher-device-search"
                         :options="medicalDevices" :multiple="false" :searchable="true" :internal-search="false"
                         :close-on-select="true" :options-limit="300" :limit="3" :max-height="400"
                         :show-no-results="false" :hide-selected="false" @search-change="getResult"
                         @select="selectMedicalDevice" selectLabel="vybrat">
              <template slot="option" scope="props">
                <div class="option__desc">
                            <span class="option__title"
                                  :class="props.option.available === true ? 'available' : 'unavailable'">
                              <div class="row m-0 pb-0 font-sm">
                                <div class="col-sm-6">
                                  <i class="fas fa-coins" style="color: goldenrod;"
                                     v-if="props.option.has_actual_insruance_cover === true"></i>
                                  {{ props.option.label }}
                                </div>
                              </div>
                              <div class="row m-0 font-xs font-weight-normal">
                                <div class="col-sm-6">
                                  <span>
                                     {{ props.option.description }}
                                  </span>
                                </div>
                              </div>
                            </span>
                </div>
              </template>
            </multiselect>
            <small id="medicalDeviceError" class="form-text font-weight-bold"
                   v-if="voucherError.medicalDevice">{{ voucherError.medicalDevice.message }}</small>
          </div>
          <div class="col-sm-1 mb-2">
            <i class="fa fa-spinner fa-pulse fa-2x fa-fw" v-if="clientMedicalDeviceInfoPending === true"></i>
          </div>
        </div>

        <div class="form-row align-items-end">
          <div class="col-sm-6 mb-2">
            <label for="searchDiagnosis">Diagnóza</label>
            <multiselect v-model="selectedDisease" id="searchDiagnosis" label="label" track-by="code" data-testid="visit-voucher-disease-search"
                         placeholder="vyhledat diagnózu" :options="diseases" :multiple="false" :searchable="true"
                         :internal-search="false" :close-on-select="true" :options-limit="300" :limit="3"
                         :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getDiseases"
                         @select="selectDisease" selectLabel=""></multiselect>
          </div>
          <div class="col-sm-6 mb-2">
            <label for="paidBySick">Hradí pacient</label>
            <div>
              <label class="switch switch-lg switch-text switch-success">
                <input v-model="voucher.paid_by_sick" type="checkbox" class="switch-input" id="paidBySick" checked data-testid="visit-voucher-paid-by-client">
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-row align-items-begin">
          <div class="col-sm-4 mb-2">
            <label for="amount">Počet balení</label>
            <input v-model="voucher.amount" type="number" class="form-control" aria-describedby="operationHelp"
                   id="amount" min="1" data-testid="visit-voucher-quantity">
          </div>
          <div class="col-sm-3 mb-2">
            <label for="temporary">Dočasná</label>
            <div>
              <label class="switch switch-lg switch-text switch-success">
                <input v-model="voucher.temporary" type="checkbox" class="switch-input" id="temporary" checked data-testid="visit-voucher-temporary">
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-4 mb-2">
            <label for="temporary_duration_months">na počet měsíců</label>
            <input v-model="voucher.temporary_duration_months" type="number" class="form-control"
                   aria-describedby="operationHelp" id="temporary_duration_months" min="1" max="365" data-testid="visit-voucher-temporary-months">
          </div>
        </div>
        <div class="form-row align-items-end">
          <div class="col-sm-3 mb-2">
            <label for="family">Rodina</label>
            <div>
              <label class="switch switch-lg switch-text switch-success">
                <input v-model="voucher.family" type="checkbox" class="switch-input" id="family" checked data-testid="visit-voucher-family">
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-3 mb-2">
            <label for="validityInDays">Platnost (dní)</label>
            <input v-model="voucher.validity_in_days" type="number" class="form-control"
                   aria-describedby="operationHelp" id="validityInDays" min="1" max="365" data-testid="visit-voucher-validity">
            <small class="form-text font-weight-bold">do {{ validToDate }}</small>
          </div>
          <div class="col-sm-6 mb-2">
            <label for="incontinence_grade">Stupeň inkontinence</label><br>
            <div class="btn-group" data-toggle="buttons">
              <label class="btn btn-primary" :class="{ active: voucher.incontinence_grade === null }">
                <input type="radio" name="options" id="option1" autocomplete="off" v-model="voucher.incontinence_grade" :value="null" data-testid="visit-voucher-incontinence-none"> ne
              </label>
              <label class="btn btn-primary" :class="{ active: voucher.incontinence_grade === 1 }">
                <input type="radio" name="options" id="option1" autocomplete="off" v-model="voucher.incontinence_grade" :value="1" data-testid="visit-voucher-incontinence-1"> 1
              </label>
              <label class="btn btn-primary" :class="{ active: voucher.incontinence_grade === 2 }">
                <input type="radio" name="options" id="option2" autocomplete="off" v-model="voucher.incontinence_grade" :value="2" data-testid="visit-voucher-incontinence-2"> 2
              </label>
              <label class="btn btn-primary" :class="{ active: voucher.incontinence_grade === 3 }">
                <input type="radio" name="options" id="option3" autocomplete="off" v-model="voucher.incontinence_grade" :value="3" data-testid="visit-voucher-incontinence-3"> 3
              </label>
            </div>
          </div>
        </div>
        <div class="form-row align-items-end">
          <div class="col-sm-3 mb-2">
            <label for="type">E-Poukaz</label>
            <div>
              <label class="switch switch-lg switch-text switch-success">
                <input v-model="voucher.electronic_prescription" type="checkbox" class="switch-input" id="type" data-testid="visit-voucher-electronic"
                       checked>
                <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-3 mb-2">
            <label for="notification">Notifikace</label>
            <select v-model="voucher.patient_notification_type" class="form-control" aria-describedby="notification"
                    id="notification" :disabled="voucher.electronic_prescription !== true" data-testid="visit-voucher-notification">
              <option v-for="(pn, index) in clientMedicalDeviceInfo.possible_notifications" :value="pn.key">{{
                  pn.label
                }}
              </option>
            </select>
          </div>
          <div class="col-sm-6 mb-2">
            <label for="payment">Úhrada (UHR)</label><br>
            <div class="btn-group" data-toggle="buttons">
              <label class="btn btn-primary" :class="{ active: voucher.payment === null }">
                <input type="radio" name="options" id="option1" autocomplete="off" v-model="voucher.payment" :value="null" data-testid="visit-voucher-payment-none"> ne
              </label>
              <label class="btn btn-primary" :class="{ active: voucher.payment === 1 }">
                <input type="radio" name="options" id="option2" autocomplete="off" v-model="voucher.payment" :value="1" data-testid="visit-voucher-payment-1"> 1
              </label>
              <label class="btn btn-primary" :class="{ active: voucher.payment === 2 }">
                <input type="radio" name="options" id="option3" autocomplete="off" v-model="voucher.payment" :value="2" data-testid="visit-voucher-payment-2"> 2
              </label>
              <label class="btn btn-primary" :class="{ active: voucher.payment === 3 }">
                <input type="radio" name="options" id="option4" autocomplete="off" v-model="voucher.payment" :value="3" data-testid="visit-voucher-payment-3"> 3
              </label>
            </div>
          </div>
<!--          <div class="col-sm-6 mb-2">-->
<!--            <label for="note">Poznámka</label>-->
<!--            <input v-model="voucher.note" type="text" class="form-control" aria-describedby="operationHelp"-->
<!--                   id="note">-->
<!--          </div>-->
        </div>

        <div class="form-row">
          <div class="col-sm-12">
            <button type="submit" class="btn btn-success btn-sm" data-testid="visit-voucher-submit">Vystavit poukaz</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  </div>
</template>

<script>
import apiMixin from '@/mixins'
import _ from 'lodash'

export default {
  data () {
    return {
      selected: null,
      selectedDisease: null,
      // medicalDevice: '',
      fromSearch: '',
      voucher: {
        medicalDevice: '',
        disease: null,
        incontinence_grade: null,
        amount: 1,
        paid_by_sick: false,
        validity_in_days: 30,
        electronic_prescription: true,
        patient_notification_type: false,
        separate: true,
        temporary: true,
        temporary_duration_months: null,
        payment: 1
      },
      originalVoucherValidityInDays: 30,
      // Voucher (post)
      voucherPending: false,
      voucherError: false,
      voucherDone: false,
      // MedicalDevices
      medicalDevices: [],
      medicalDevicesError: false,
      medicalDevicesPending: false,
      // Diseases
      diseases: [],
      diseasesPending: false,
      diseasesError: false,
      // client medicalDevice info
      clientMedicalDeviceInfo: false,
      clientMedicalDeviceInfoPending: false,
      clientMedicalDeviceInfoError: false,
      clientMedicalDeviceInfoDone: false,
      readyToDuplicate: false
    }
  },
  mixins: [apiMixin],
  props: ['copiedVoucher', 'clientId', 'visitId'],
  methods: {
    getResult: _.debounce(function (text) {
      if (text.length > 2) {
        this.getMedicalDevices(text)
      }
    }, 600),
    duplicateMedicalDeviceByCode (code) {
      this.readyToDuplicate = true
      this.getMedicalDevices(code)
    },
    saveVoucher () {
      for (let property in this.voucher) {
        if (this.voucher.hasOwnProperty(property) && this.voucher[property] === '') {
          this.voucher[property] = null
        }
      }
      this.voucherError = false
      this.postVoucher(this.voucher, this.clientId, this.visitId)
    },
    selectMedicalDevice (val) {
      this.voucher.medicalDevice = {'code': val.code}
      this.getClientMedicalDeviceInfo(this.clientId, '0000009')
    },
    voucherAdded () {
      this.$emit('update')
    },
    selectDisease (val) {
      this.voucher.disease = {'code': val.code}
    }
  },
  computed: {
    validToDate () {
      return this.$moment().add(this.voucher.validity_in_days, 'days').format('L')
    }
  },
  watch: {
    'voucher.incontinence_grade' (val) {
      if (val === 3) {
        this.voucher.payment = 3
      } else if (val === 2) {
        this.voucher.payment = 2
      } else if (val === 1) {
        this.voucher.payment = 1
      }
    },
    medicalDevicesPending (val) {
      if (val === false && this.readyToDuplicate === true) {
        this.selected = this.medicalDevices[0]
        this.selectMedicalDevice({code: this.medicalDevices[0].code})
      }
    },
    voucherPending (val) {
      if (val === false) {
        this.voucher = {
          medicalDevice: '',
          disease: null,
          incontinence_grade: null,
          amount: 1,
          paid_by_sick: false,
          validity_in_days: 30,
          electronic_prescription: true,
          patient_notification_type: false,
          separate: true,
          temporary: true,
          temporary_duration_months: null,
          payment: 1
        }
        this.clientMedicalDeviceInfo = false
        this.selected = null
        this.selectedDisease = null
        this.$emit('update')
        this.voucherDone = false
      }
    },
    clientMedicalDeviceInfoDone (val) {
      if (val === true && this.readyToDuplicate === true) {
        this.voucher.disease = this.copiedVoucher.disease
        this.voucher.amount = this.copiedVoucher.amount
        this.voucher.family = this.copiedVoucher.family
        this.voucher.paid_by_sick = this.copiedVoucher.paid_by_sick

        if (this.copiedVoucher && this.copiedVoucher.patient_notification_type) {
          this.voucher.patient_notification_type = this.copiedVoucher.patient_notification_type
        } else {
          this.voucher.patient_notification_type = this.clientMedicalDeviceInfo.possible_notifications[this.clientMedicalDeviceInfo.possible_notifications.length - 1].key
        }
        this.voucher.validity_in_days = this.clientMedicalDeviceInfo.validity
        this.originalVoucherValidityInDays = this.clientMedicalDeviceInfo.validity

        this.readyToDuplicate = false
      } else if (val === true) {
        if (this.clientMedicalDeviceInfo.disease) {
          this.selectedDisease = this.clientMedicalDeviceInfo.disease
          this.selectDisease(this.clientMedicalDeviceInfo.disease)
        } else {
          this.selectedDisease = null
          this.voucher.disease = null
        }
        this.voucher.patient_notification_type = this.clientMedicalDeviceInfo.possible_notifications[this.clientMedicalDeviceInfo.possible_notifications.length - 1].key
        this.voucher.paid_by_sick = this.clientMedicalDeviceInfo.paid_by_sick
        this.voucher.validity_in_days = this.clientMedicalDeviceInfo.validity
        this.originalVoucherValidityInDays = this.clientMedicalDeviceInfo.validity
      }
    },
    copiedVoucher (val) {
      if (val !== null) {
        this.duplicateMedicalDeviceByCode(val.medicalDevice.code)
      }
    }
  }
}
</script>

<style>
span.multiselect__option {
  min-height: 10px !important;
  padding: 3px !important;
}

div.multiselect__content-wrapper {
  z-index: 1050 !important;
}

span.option__title.available {
  color: #000;
  font-weight: bolder;
}

span.option__title.unavailable {
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/Voucher/AddVoucher.vue?972b3d58